export default __webpack_public_path__ + "static/media/home_banner.314a7549.png";